var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-embed gfu-embed--16x9 _flexcntr _ai-c" },
    [
      _c(
        "transition",
        { attrs: { name: "gfu-fade", mode: "out-in" } },
        [
          _vm.shouldBlockVideo
            ? _c("privacy-placeholder", {
                staticClass: "gfu-embed__item _bgc--white",
              })
            : _vm.isVisible
            ? _c("iframe", {
                ref: `iframe:${_vm.videoUrl}`,
                class: [
                  "gfu-embed__item _bgc--primary-dark",
                  { "youtube-player": _vm.isYoutube },
                ],
                attrs: {
                  src: _vm.videoUrl,
                  frameborder: "0",
                  width: "100%",
                  height: "100%",
                  loading: "lazy",
                  referrerpolicy: "strict-origin-when-cross-origin",
                  allow:
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                  allowfullscreen: "",
                },
              })
            : _c(
                "div",
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "gfu-gallery__play-button",
                      attrs: { theme: "primary" },
                      on: { click: _vm.onPlay },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.Resources.Common.PlayVideoButton) +
                          "\n                "
                      ),
                      _c("base-icon", {
                        attrs: {
                          name: "play-solid",
                          "icon-namespace": "ga",
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }